/* eslint-disable max-len */
import { checkDateIsInSamePeriod } from 'app/utils/checkDateIsInSamePeriod';

const PAGE = 'creativity';

export const allDishes = [3843, 122, 3995, 3813, 3857].map((id) => String(id));


const dishesData = allDishes.reduce((acc, id, index) => {
    const data = {
        id,
        orderNumber: index + 1,
    };
    return {
        ...acc,
        [id]: data,
    };
}, {});


export default {
    pageId: PAGE,
    pathSegment: PAGE,
    pathSegmentEn: PAGE,

    title: 'Интересные рецепты для творчества | Elementaree',
    description: 'Создавайте новые семейные традиции: наборы, чтобы провести интересный выходной дома',

    ogImage: '',
    additionalContent: '',
    onInit: () => { },
    appConfig: {
        pageId: PAGE,
        city: null,
        period: null,
        firstPeriodStart: '2023-05-01',
        filterByIds: allDishes,

        areAvaliableDishesPersistentForPeriods: false,

        joinDishTitlesinMobile: false,
        dishesData,
        dishCategories: {
            main: {
                id: 'main',
                title: 'Время для творчества',
                titleEn: 'Время для творчества',
                detailsTitle: 'Время для творчества',
                description: [],
                enabledDishes: allDishes,
            },
        },
        canChangePortionsCount: true,
        areDetailsEnabled: true,

        enabledBasketDishIds: [],
        autoFillingBasket: false,

        isCheckoutEnabled: true,
        isLinkToMenuEnabled: true,

        prepareDates: (dates, periodsConfig = null, period = null, basketDishesIds) => dates.filter((d) => checkDateIsInSamePeriod(d.date, period)),

        prepareIntervals: null,

        ageGate: false,
        openBasketButtonType: 'scrollToCheckout',
        ageGateImage: null,
    },
};
